// extracted by mini-css-extract-plugin
module.exports = {"dialogRoot":"IncompatibleBrowserModal_dialogRoot__18uCO","messageBox":"IncompatibleBrowserModal_messageBox__1OAgq","messageCtaImg":"IncompatibleBrowserModal_messageCtaImg__6FCR1"};